import { render } from "./HeroiconsOutlineFolder.vue?vue&type=template&id=1fcee8fd"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolder.vue"]])

export default __exports__